.compare-version{display:flex;flex-direction:column;gap:15px}
/*# sourceMappingURL=compare-summary-rules-dialog.component-WKBL5CDY.css.map */
